<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Cover: The Battle for WondLa, by Tony DiTerlizzi, illustrated by Tony DiTerlizzi" aria-describedby="cover-alt" class="imagefp" role="doc-cover" src="e9781481403887/images/9781481403887.jpg"/></div>
<aside hidden="hidden" id="cover-alt">
<p>The Battle for WondLa</p>
<p>Written and Illustrated by #1 <i>New York Times</i> Bestselling Author</p>
<p>Tony DiTerlizzi</p>
</aside>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?2a3b0453